import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useFeatureAccess } from '../../hooks/useFeatureAccess';

interface ModuleGuardProps {
  module: string;
  children: ReactNode;
}

/**
 * Componente que protege rotas baseado em módulos do plano
 * Redireciona para a central de planos quando o módulo não está coberto
 */
export const ModuleGuard = ({ module, children }: ModuleGuardProps) => {
  const location = useLocation();
  const { hasModule, getRequiredPlano } = useFeatureAccess();

  if (!hasModule(module)) {
    const params = new URLSearchParams();
    const requiredPlano = getRequiredPlano(module);

    if (requiredPlano) params.set('plano', requiredPlano);
    params.set('feature', module);
    params.set('source', 'module-guard');
    params.set('from', location.pathname);

    return <Navigate to={`/planos-cobranca?${params.toString()}`} replace />;
  }

  return <>{children}</>;
};
